// src/locales/en/attributes.js
export const attributes = {

    // Page titles and descriptions
    title: "Product Attributes",
    description: "Manage product attributes and their values for better product organization",
    
    // Navigation
    addAttribute: "Add Attribute",
    createNewAttribute: "Create New Attribute",
    editAttribute: "Edit Attribute",
    createFirstAttribute: "Create First Attribute",
    
    // Form Fields
    attributeName: "Attribute Name",
    attributeNamePlaceholder: "Enter attribute name (e.g., Size, Color, Material)",
    values: "Values",
    valuePlaceholder: "Enter value {{index}}",
    addValue: "Add Value",
    removeValue: "Remove Value",
    valueCount: "Values",
    
    // Table Headers
    filteredResults: "{{count}} of {{total}} attributes",
    totalAttributes: "{{count}} attributes",
    searchAttributes: "Search attributes by name or values...",
    
    // Validation Messages
    nameRequired: "Attribute name is required",
    nameMinLength: "Attribute name must be at least 2 characters",
    valuesRequired: "At least one value is required",
    duplicateValues: "Duplicate values are not allowed",
    
    // Actions
    createAttribute: "Create Attribute",
    updateAttribute: "Update Attribute",
    
    // Success/Error Messages
    attributeCreatedSuccess: "Attribute '{{attributeName}}' created successfully!",
    attributeUpdatedSuccess: "Attribute '{{attributeName}}' updated successfully!",
    attributeDeletedSuccess: "Attribute '{{attributeName}}' has been deleted successfully.",
    failedToCreate: "Failed to create attribute. Please try again.",
    failedToUpdate: "Failed to update attribute. Please try again.",
    failedToDelete: "Failed to delete attribute. Please try again.",
    failedToLoadAttribute: "Failed to load attribute details. Please try again.",
    
    // Loading states
    loadingAttributes: "Loading Attributes...",
    loadingAttributesDesc: "Please wait while we fetch your product attributes.",
    
    // Empty states
    noAttributes: "No attributes yet",
    noAttributesDesc: "Create your first product attribute to start organizing your products by specific characteristics.",
    noSearchResults: "No attributes found",
    noSearchResultsDesc: "Try adjusting your search terms or clear filters to see all attributes.",
    
    // Confirmation dialogs
    confirmDelete: "Are you sure you want to delete the attribute '{{attributeName}}'? This action cannot be undone and may affect products using this attribute."
}